/**
 * ============================================================================
 * useRejectMutation — Phase 6c frontend (CCIE).
 * Owner: Claude 3 (Frontend & UX).
 * Purpose: POST /api/v1/changes/{id}/reject — record the rejection of a CC
 *          proposal. A reason is required so the audit chain captures the
 *          QA reviewer's justification.
 * ============================================================================
 */

import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { apiFetch, newIdempotencyKey } from '../../api/client';

export interface RejectInput {
  changeId: string;
  reason: string;
  signatureBundleId: string;
}

export interface RejectResponse {
  change_id: string;
  status: string;
  rejected_at_utc: string;
}

export function useRejectMutation(): UseMutationResult<
  RejectResponse,
  Error,
  RejectInput
> {
  return useMutation<RejectResponse, Error, RejectInput>({
    mutationFn: ({ changeId, reason, signatureBundleId }) =>
      apiFetch<RejectResponse>(
        `/api/v1/changes/${encodeURIComponent(changeId)}/reject`,
        {
          method: 'POST',
          body: {
            reason,
            signature_bundle_id: signatureBundleId,
          },
          idempotencyKey: newIdempotencyKey(),
        },
      ),
  });
}
